export class ImageProcessor {
    rotateCanvas(angle: number, canvas: any, image: any) {
        const img = new Image;
        const img2 = new Image;
        const ctx = canvas.getContext('2d');

        img.onload = function () {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            if (angle === 90 || angle === 270) {
                canvas.width = img.height;
                canvas.height = img.width;
            } else {
                canvas.width = img.width;
                canvas.height = img.height;
            }
            ctx.save();
            ctx.translate(canvas.width / 2, canvas.height / 2);
            ctx.rotate(angle * Math.PI / 180);
            ctx.drawImage(img, -img.width / 2, -img.height / 2);
            ctx.restore();
            img2.src = canvas.toDataURL('image/png');
        }

        img2.onload = function () {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            const w = canvas.width;
            const h = canvas.height;
            const scale_w = 500 * w / h;
            const scale_h = 800 * h / w;
            if (h > w) {
                canvas.height = 500;
                canvas.width = (h < 500 || scale_w > 800) ? 800 : scale_w;
            } else {
                canvas.width = 800;
                canvas.height = (w < 800 || scale_h > 500) ? 500 : scale_h;
            }
            ctx.drawImage(img2, 0, 0, canvas.width, canvas.height);
            canvas.drawedImg = canvas.toDataURL('image/png');
        }

        img.src = image;
    }

    clearCanvas(canvas: any, ori_data: any) {
        const ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, 800, 500);
        const img = new Image;
        img.onload = function() {
            const scale_w = 500 * img.width / img.height;
            const scale_h = 800 * img.height / img.width;
            if (img.height > img.width) {
                canvas.height = 500;
                canvas.width = (img.height < 500 || scale_w > 800) ? 800 : scale_w;
            } else {
                canvas.width = 800;
                canvas.height = (img.width < 800 || scale_h > 500) ? 500 : scale_h;
            }
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            canvas.drawedImg = canvas.toDataURL('image/png');
        }
        img.src = ori_data;
    }

    biggerCanvas(canvas: any, scale_cnt: number) {
        const img = new Image;
        const ctx = canvas.getContext('2d');
        const scale = Math.pow(1.1, scale_cnt);
        const w = (canvas.width * 1.1) < 800 ? (canvas.width * 1.1) : 800;
        const h = (canvas.height * 1.1) < 500 ? (canvas.height * 1.1) : 500;

        img.onload = function () {
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            canvas.width = w;
            canvas.height = h;
            ctx.clearRect(0, 0, w, h);
            ctx.scale(scale, scale);
            ctx.drawImage(img, 0, 0);
        }

        img.src = canvas.drawedImg;
    }
};



// WEBPACK FOOTER //
// ./src/app/shared/component/imageprocessor/imageprocessor.ts